import { useCallback } from "react";


export const useApplyFeedbackFilters = ({
    filters,
    fetchMultipleDistributions,
    setDistributionData,
    handleFeedbackFilterChange,
    setLoading,
    setErrors,
    setFeedbackData,
    setFeedbackStats,
    setComplaintsCount,
    fetchFeedbackStats,
}) => {
    const handleApplyFeedbackFilters = useCallback(async () => {
        try {
            let attributes = [];
            let newAttribute = 'Sector';

            const sectorFilled = filters.Sector && filters.Sector !== 'All';
            const companyFilled = filters.CompanyName && filters.CompanyName !== 'All';

            // Determine which attributes to fetch based on drill-down level
            if (!sectorFilled && !companyFilled) {
                attributes = ['Sector'];
                newAttribute = 'Sector';
            } else if (sectorFilled && !companyFilled) {
                attributes = ['CompanyName'];
                newAttribute = 'CompanyName';
            } else if (companyFilled) {
                attributes = ['Category'];
                newAttribute = 'Category';
            }

            // Update the attribute
            handleFeedbackFilterChange('attribute', newAttribute);

            const baseFilters = {
                startDate: filters.startDate,
                endDate: filters.endDate,
                Sector: filters.Sector || 'All',
                CompanyName: filters.CompanyName || 'All',
                Category: filters.Category || 'All',
                skip: filters.skip || 0,
                limit: filters.limit || 1000
            };

            // Fetch distribution data
            await fetchMultipleDistributions(attributes, baseFilters, setDistributionData, setLoading, setErrors);

            // Fetch feedback stats
            const statsData = await fetchFeedbackStats(baseFilters, setFeedbackStats);
            setComplaintsCount(statsData?.total_feedback_count || 0);

            // Note: FeedbackComponent will fetch ratings on demand when user clicks sentiment buttons
            // No need to fetch all ratings here

        } catch (error) {
            console.error('Error applying feedback filters:', error);
        }
    }, [filters, fetchMultipleDistributions, setDistributionData, setLoading, setErrors, setFeedbackData, setFeedbackStats, setComplaintsCount, handleFeedbackFilterChange, fetchFeedbackStats]);

    return { handleApplyFeedbackFilters };
};
